import { env } from "@superadmin/configs/env.config";
import { resolveAuthBaseUrl } from "@voicely/web-shared/api_base_url";
import { createAuthClient } from "better-auth/client";

// Empty VITE_API_URL = same-origin reverse-proxy deploy. Fall back to the
// current page origin so better-auth talks to the visible domain, whose
// nginx forwards /api/auth/* to the backend.
//
// No `inferAdditionalFields` plugin here: this app never writes user fields
// (timezone, theme, digest times are the tenant dashboard's business), so it
// does not need their types on the client.
const authBaseUrl = resolveAuthBaseUrl(env.VITE_API_URL);

export const authClient = createAuthClient({
	baseURL: authBaseUrl,
});
